import { gql } from "graphql-request";
import {
  FRAGMENT_SCREEN_SCHEDULE,
  FRAGMENT_DIGITAL_RECEPTION_THEME,
  FRAGMENT_CLIENT_PREFERENCES,
  FRAGMENT_OWNER,
  FRAGMENT_ENTRANCE_AGREEMENT,
  FRAGMENT_DIGITAL_RECEPTION_SETTINGS,
} from "./fragments";

export const QUERY_ACCESS_EVENT = gql`
  query accessEvent($id: ID!) {
    accessEvent(id: $id) {
      type
      owner {
        ...FragmentAccessEventOwner
      }
      receiver {
        id
        phone
        fullName
        availablePreferences {
          ...FragmentEmployeePreferences
        }
      }
      customReceiver {
        phone
      }
    }
  }
  ${FRAGMENT_OWNER}
`;

export const QUERY_EMPLOYEES = gql`
  query employees(
    $filter: EmployeeFilterType
    $sort: EmployeeSortType
    $pagination: Pagination
  ) {
    employees(filter: $filter, sort: $sort, pagination: $pagination) {
      id
      fullName
      email
      phone
    }
  }
`;

export const QUERY_DIGITAL_RECEPTION = gql`
  query digitalReception($id: ID!, $language: String) {
    digitalReception(id: $id, language: $language) {
      id
      client {
        id
        plan
        preferences {
          ...FragmentClientPreferences
        }
      }
      metadata
      language
      languages
      theme {
        ...FragmentDigitalReceptionTheme
      }
      schedules {
        ...FragmentScreenSchedule
      }
      entranceAgreement {
        ...FragmentEntranceAgreement
      }
      settings {
        ...FragmentDigitalReceptionSettings
      }
      building {
        title
        address
        city
        zipCode
        country
      }
      code
      communicationProvider
      teams {
        id
      }
      googleChat {
        id
      }
    }
  }
  ${FRAGMENT_SCREEN_SCHEDULE}
  ${FRAGMENT_CLIENT_PREFERENCES}
  ${FRAGMENT_DIGITAL_RECEPTION_THEME}
  ${FRAGMENT_ENTRANCE_AGREEMENT}
  ${FRAGMENT_DIGITAL_RECEPTION_SETTINGS}
`;

export const QUERY_CURRENTLY_CHECKED_IN = gql`
  query currentlyCheckedIn(
    $companyId: ID
    $filter: AccessEventFilterType
    $pagination: Pagination
  ) {
    currentlyCheckedIn(
      companyId: $companyId
      filter: $filter
      pagination: $pagination
    ) {
      events {
        type
        owner {
          ...FragmentAccessEventOwner
        }
        receiver {
          fullName
        }
        metadata
      }
    }
  }
  ${FRAGMENT_OWNER}
`;

export const QUERY_DIGITAL_RECEPTION_PUBLIC = gql`
  query digitalReception($input: InputDigitalReceptionPublic!) {
    digitalReceptionPublic(input: $input) {
      playerUrl
    }
  }
`;

export const QUERY_MEMBER_CODE_CHECK = gql`
  query getMemberTypeAndPhotoStatusByCode($code: String!) {
    getMemberTypeAndPhotoStatusByCode(code: $code) {
      type
      hasPhoto
    }
  }
`;
